import { fromRgbHexValue } from "./palette";

export type ColorProgressProps = {
  color: number;
  progress: number; // 0..1
};

export default function ColorProgress({ color, progress }: ColorProgressProps) {
  const [r, g, b] = fromRgbHexValue(color);
  const lum = 0.299 * r + 0.587 * g + 0.114 * b;
  const trackBg = lum > 186 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.4)";
  const clamped = Math.max(0, Math.min(1, progress));

  return (
    <div
      style={{
        width: "100%",
        height: 6,
        background: trackBg,
        borderRadius: 3,
        overflow: "hidden",
        flex: "0 0 auto",
      }}
    >
      <div
        style={{
          width: "100%", // fixed
          height: "100%",
          background: `rgb(${r},${g},${b})`,
          transform: `scaleX(${clamped})`,
          transformOrigin: "0 50%",
          transition: "transform 200ms ease",
          willChange: "transform",
        }}
      />
    </div>
  );
}
